<template> 
    <div > 
        <div class="crumbs" hidden="true" style="margin-left:10px;" >
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 商品管理
                </el-breadcrumb-item>
                 <el-breadcrumb-item>添加商品</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
          <el-card shadow="hover"  class="searchCard" >
                <span class="label-span">
                    <label class="label">系统产品名称</label> 
                     <el-select v-model="query.goodsId" multiple collapse-tags  placeholder="产品名称，可多选" filterable  clearable style="width:350px;" class=" mr10">
                        <el-option value="" label="全部"  />  
                        <el-option v-for="item in select.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </span> 
                <span class="label-span">
                    <label class="label">系统产品编码</label> 
                    <el-input v-model.trim="query.goodsCode" placeholder="系统产品编码" style="width:120px;" class="handle-input mr10"></el-input> 
                </span> 
                <span class="label-span">
                    <label class="label">产品计费通道</label> 
                    <el-select v-model="query.isps"  placeholder="计费通道" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />
                        <el-option value="1" label="移动"  /> 
                        <el-option value="2" label="联通"  /> 
                        <el-option value="3" label="电信"  />  
                        <el-option value="0" label="自收款" /> 
                        <el-option value="9" label="代收款" />    
                    </el-select>  
                </span> 
                <span class="label-span">
                    <label class="label">上架状态</label> 
                    <el-select v-model="query.status"  placeholder="产品状态" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />    
                        <el-option value="1" label="已上架"  /> 
                        <el-option value="0" label="已下架"  />    
                    </el-select>
                </span>  
                <span :hidden="showDiv"> 
                <span class="label-span">
                    <label class="label">推广状态</label> 
                    <el-select v-model="query.promoteStatus"  placeholder="推广状态" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />    
                        <el-option value="1" label="推广中"  /> 
                        <el-option value="0" label="已暂停"  />     
                    </el-select>
                </span>   
                <span class="label-span">
                    <label class="label">产品分类</label> 
                    <el-select v-model="query.goodsType"  placeholder="产品分类" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option v-for="item in select2.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </span> 
                <span class="label-span">
                    <label class="label">产品资费</label> 
                    <el-input v-model.trim="query.goodsRate"  oninput="value=value.replace(/[^0-9.]/g,'')" placeholder="小于等于/元" style="width:120px;" class="handle-input mr10"></el-input> 
                </span>
                <span class="label-span">
                    <label class="label">产品来源</label> 
                    <el-select v-model="query.goodsFrom"  placeholder="产品来源" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option v-for="item in select3.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </span>  
                <span class="label-span">
                    <label class="label">结算类型</label> 
                    <el-select v-model="query.goodsComType"  placeholder="结算类型" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  /> 
                        <el-option value="1" label="CPA"  /> 
                        <el-option value="2" label="CPS"  />  
                    </el-select> 
                </span>  
                <span class="label-span">
                    <label class="label">推广范围</label> 
                    <el-cascader collapse-tags v-model.trim="query.promoteArea" style="width:240px;margin-right:10px;" filterable clearable :options="select5.option" :props="{ multiple: true }" collapse-tags></el-cascader>
                </span>
                <span class="label-span">
                    <label class="label">产品标签</label> 
                    <el-select multiple collapse-tags v-model="query.goodsTag" style="width:230px;" placeholder="产品标签" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />  
                        <el-option v-for="item in select4.option" :key="item.id" :label="item.optVal" :value="item.optKey" /> 
                    </el-select>
                </span>
            </span>     
            <el-tooltip  :content="showDiv?'展开更多筛选条件':'收起更多筛选条件'" placement="top">
                <el-button type="error"  class="mr10"  @click="showMore"> {{show}} </el-button>
            </el-tooltip>   
                <el-button type="success" icon="el-icon-search" class="mr10"   @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr15"   @click="refreshSearch">重置</el-button> 
                <el-button type="primary" class="mr10"   @click="addBind" >新增组品</el-button> 
                <!--<el-button type="error" icon="el-icon-lx-down"  class="handle-del "  @click="downStatus" >批量下架</el-button> 
                <el-button type="danger" icon="el-icon-lx-delete"   @click="changeGrade" >批量删除</el-button> -->
                 
               
          </el-card>
          <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" border modal="true" size="mini" height="600px"  class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange" 
             v-loading="loading3"  element-loading-text="" element-loading-spinner="el-icon-loading" >
                <el-table-column prop="masterImg" width="100" align="center" label="产品主图">
                    <template slot-scope="scope" > 
                        <img :src="scope.row.goodsImg" style="width:70px;height:70px;border-radius:5px;" @click="getImgDetail(scope.row.goodsCode)" />   
                    </template>
                </el-table-column>   
                <el-table-column prop="goodsName" min-width="230" align="left" label="组品信息">
                    <template slot-scope="scope" >
                        <p style="font-size:14px;line-height:18px;color:#777;">
                            产品分类：{{scope.row.channelName}} <el-tag :style="scope.row.isp==1?'background:#409eff;color:#fff;':scope.row.isp==2?'background:#fd7a7a;color:#fff;':scope.row.isp==3?'background:#3f3d3d;color:#fff;':scope.row.isp==0?'background:#2ade6e;color:#fff;':scope.row.isp==9?'background:#ed5fbe;color:#fff;':'background:#999;color:#fff;'">
                                {{scope.row.isp==1?'移动':scope.row.isp==2?'联通':scope.row.isp==3?'电信':scope.row.isp==0?'自收款':scope.row.isp==9?'代收款':'其它'}}
                                </el-tag><span style="font-size:12px;color:#666;margin-left:5px;">{{scope.row.goodsFromName}}-{{scope.row.goodsTypeName}}</span><br> 
                            产品编码：<el-link @click="copyLink(scope.row.goodsCode,'产品编码')" style="text-align:center;font-size:12px;"  type="primary"><b>{{scope.row.goodsCode}}</b></el-link><br>
                            产品名称：<span @click="copyLink(scope.row.goodsName,'产品名称')" style="text-align:center;font-size:12px;font-weight:700;color:#409EFF">{{scope.row.goodsName}}</span> 
                           
                        </p>
                    </template>
                </el-table-column> 
                <el-table-column prop="channel" min-width="220" align="left" label="子品信息">
                    <template slot-scope="scope" >
                        <p style="font-size:14px;line-height:18px;color:#777;">   
                            <span style=“font-size:12px;”>{{scope.row.channelTypeName}}：{{scope.row.channelName}}</span>  <br>
                            上游编码：<span @click="copyLink(scope.row.channelGoodsCode,'上游商品编码')" style="font-size:12px;color:#be9d1d;font-weight:700">{{scope.row.channelGoodsCode}}</span> <br>
                            上游商品：<span @click="copyLink(scope.row.channelGoodsName,'上游商品名称')" style="font-size:12px;color:#be9d1d;font-weight:700">{{scope.row.channelGoodsName}}</span> 

                        </p>
                    </template>
                </el-table-column> 
                <el-table-column prop="goodsName" min-width="150" align="left" label="资费结算">
                    <template slot-scope="scope" >
                        <p style="font-size:14px;color:#777;">  
                            <el-tag type="danger">资费：{{scope.row.goodsRate}}</el-tag><br> 
                            <el-tag type="danger" ><b>结算：￥{{scope.row.goodsCom}}元</b></el-tag><br>
                            
                        </p>
                    </template>
                </el-table-column>
                <el-table-column prop="status" width="80" align="center" label="商品状态">
                    <template slot-scope="scope" >  
                        <el-tooltip :content="scope.row.status=='1'?'已上架':'已下架'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip> 
                    </template> 
                </el-table-column>
                <el-table-column prop="status" width="80" align="center" label="投放状态">
                    <template slot-scope="scope" >  
                        <el-tooltip :content="scope.row.promoteStatus=='1'?'已开启':scope.row.promoteInfo" placement="top">
                            <el-switch @change="handleProStatus(scope.$index, scope.row)"
                                v-model="scope.row.promoteStatus"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template> 
                </el-table-column>  
                <!--<el-table-column prop="detail" width="220" align="left" label="商品说明"></el-table-column>
                <el-table-column prop="cashPolicy" width="200" align="left" label="结算规则"></el-table-column> --> 
                <el-table-column prop="createTime" min-width="240" align="left"  label="操作时间">
                    <template slot-scope="scope" >
                        <span >添加时间：{{scope.row.createTime}} </span><br>
                        <p style="margin-top:15px;">下架时间：{{scope.row.updateTime}} </p>
                    </template> 
                </el-table-column> 
                <el-table-column label="操作" width="150" align="center" fixed="right">
                    <template slot-scope="scope"> 
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>   <br>
                         <el-dropdown style="margin:8px 0px 0 0px;">
                            <span class='tableOperBtn' ><i class='el-icon-lx-attention'></i> 查看</span> 
                            <el-dropdown-menu slot="dropdown">
                                <span class='tableOperBtn2' @click="getLink2(scope.row.goodsName+'-落地页链接',scope.row.goodsCode)">
                                    落地页链接
                                </span>
                                <br>
                                <span class='tableOperBtn2' @click="getLink1(scope.row.goodsName+'-资料页链接',scope.row.goodsCode)">
                                    资料页链接
                                </span>
                                <br>
                                <span class='tableOperBtn2' @click="showLink1(scope.row)">打开资料页</span>
                                <br>
                                <span class='tableOperBtn2' @click="showLink2(scope.row)">打开落地页</span>
                                <br>
                                <span class='tableOperBtn2' @click="showLink3(scope.row)">产品测试</span>
                            </el-dropdown-menu>
                        </el-dropdown>
                        <el-dropdown  style="margin:8px 0px 0 0px;">
                            <span class='tableOperBtn' type="error">
                                <i class='el-icon-setting'></i> 配置
                            </span>
                            <el-dropdown-menu slot="dropdown"> 
                                <span class='tableOperBtn2' @click="sonConfig(scope.row)" >组品配置</span><br> 
                                <span class='tableOperBtn2' @click="memConfig(scope.row)" >渠道分配</span><br> 
                            </el-dropdown-menu>
                        </el-dropdown> 
                       
                    </template>
                </el-table-column>     
            </el-table>
            <div class="pagination">
                <el-pagination 
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50, 200]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
        </el-card>
        <!-- 新建商品弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增组品"  :visible.sync="addVisible" :modal-append-to-body='false'  width="800px" top="30px">
            <el-form ref="form1" :model="form" label-width="90px"  v-loading="loading"  :element-loading-text="loadingTitle" element-loading-spinner="el-icon-loading" @submit.native.prevent="saveForm"> 
                 
                 
                <div>
                <p class="titleInfo" style="margin-top:-10px">产品信息</p>  
                <el-form-item label="产品分类" required style="width:28%;display:inline-block;margin-top:-10px ">
                     <el-select v-model.trim="form1.goodsType" placeholder="请选择产品分类" style="margin-top:-10px"  > 
                            <el-option v-for="item in select2.option" :key="item.id" :label="item.optVal" :value="item.optKey" />    
                    </el-select>  
                </el-form-item>  
                 <el-form-item label="产品来源" required style="width:28%;display:inline-block;margin-top:-10px">
                     <el-select v-model.trim="form1.goodsFrom" placeholder="请选择产品来源" style="width:100%; margin-top:-10px"   > 
                        <el-option v-for="item in select3.option" :key="item.id" :label="item.optVal" :value="item.optKey" />  
                    </el-select>  
                </el-form-item>  
                <el-form-item label="产品名称" required style="width:44%;display:inline-block;margin-top:-10px" >
                    <el-input  type="text" placeholder="填写产品名称" style="width:100%;; margin-top:-10px" v-model.trim="form1.goodsName"  ></el-input>
                </el-form-item>  
                <el-form-item label="商品资费" required style="width:28%;display:inline-block;  margin-top:-15px" >
                    <el-input  placeholder="商品资费"  style="width:100px;; margin-top:-10px"  v-model.trim="form1.goodsRate"   oninput="value=value.replace(/[^0-9.]/g,'')"  ></el-input> 元
                </el-form-item>    
                <el-form-item label="计费通道" required style="width:28%;display:inline-block;  margin-top:-10px">
                     <el-select v-model.trim="form1.isp" placeholder="请选择"  style="; margin-top:-10px" > 
                        <el-option label="移动" value="1" />
                        <el-option label="联通" value="2" />
                        <el-option label="电信" value="3" /> 
                        <el-option label="自收款" value="0" /> 
                        <el-option label="代收款" value="9" />    
                    </el-select>  
                </el-form-item>   
                <template> 
                    <el-form-item label="产品佣金" required style="width:40%;display:inline-block; margin-top:-15px" >
                        <el-input   v-model.trim="form1.goodsCom" placeholder="单位元" style="width:120px; margin-top:-10px "  oninput="value=value.replace(/[^0-9.]/g,'')" ></el-input>
                        元
                    </el-form-item> 
                </template>     
                <el-form-item label="冷静时长" style="width:28%;display:inline-block;margin-top:-10px ">
                     <el-input  v-model.trim="form1.coolTime"   placeholder="单位分钟" style="width:85px; margin-top:-10px "   oninput="value=value.replace(/[^0-9.]/g,'')"   ></el-input>
                        分钟
                </el-form-item>  
                 <el-form-item label="办理年龄" style="width:28%;display:inline-block;margin-top:-10px">
                    <el-input  v-model.trim="form1.ageRange"   placeholder="办理年龄" style="width:100%;; margin-top:-10px"   ></el-input> 
                </el-form-item>  
                <el-form-item label="投放时间" required style="width:44%;display:inline-block;margin-top:-10px" >
                    <el-time-select v-model="form1.promoteStart" value-format="HH:mm" style="width:120px;; margin-top:-10px"  placeholder="开始时间" :picker-options="{  start: '00:00', step: '00:30', end: '24:00' }"></el-time-select>
                    <el-time-select v-model="form1.promoteEnd" value-format="HH:mm" style="width:120px;; margin-top:-10px"   placeholder="结束时间" :picker-options="{  start: '00:00', step: '00:30', end: '36:00' }"></el-time-select>
                </el-form-item> 
                  
                <el-form-item label="订购条款" style="width:56%;display:inline-block; margin-top:-10px" >
                   <el-select multiple v-model.trim="goodsRead" placeholder="请选择" style="width:100%; margin-top:-10px"   filterable clearable  > 
                        <el-option v-for="item in select7.option" :key="item.id" :label="item.optVal" :value="item.optKey" />  
                    </el-select>   
                </el-form-item>   
                <el-form-item label="组品逻辑" required style="width:44%;display:inline-block;  margin-top:-10px">
                    <el-select v-model.trim="form1.channelCode" placeholder="请选择组品逻辑" style="width:100%;;margin-top:-10px" class="handle-select mr10"> 
                        <el-option v-for="item in select6.option" :key="item.id" :label="item.optVal" :value="item.optKey" />    
                    </el-select>
                </el-form-item>   
                </div>
                <div>    
                <el-form-item label="产品标签"  required style="width:100%;display:inline-block; margin-top:-10px" >
                   <el-select multiple  collapse-tags v-model.trim="goodsTag" placeholder="请选择" style="width:100%; margin-top:-10px"  filterable clearable > 
                        <el-option v-for="item in select4.option" :key="item.id" :label="item.optVal" :value="item.optKey" />  
                    </el-select>   
                </el-form-item>   
                <div style="width:56%;float:left;margin-right:1%; ">
                    <p class="titleInfo" style="margin-top:-10px;margin-bottom:0px;">落地页内容</p>  
                    <el-button style="float:right;margin-top:-30px;height:30px;background:#0094d8;border:none;border-left:1px solid #fff" type="danger" size="small" @click="addContent">添加富文本内容</el-button>
                    <el-upload action="#" list-type="picture-card" :file-list="fileList" :on-remove="handleRemove" :on-change="handleChange" multiple="true" :limit="9" :on-exceed="overMaxImg" :auto-upload="false" >
                        <i slot="default" class="el-icon-plus" tip="点击或拖动上传"></i>
                            <div slot="file" slot-scope="{file}">
                                <img class="el-upload-list__item-thumbnail" :src="file.url" alt=""  >
                                <span class="el-upload-list__item-actions"> 
                                    <span class="el-upload-list__item-preview"  @click="handlePictureCardPreview(file)">
                                        <i class="el-icon-zoom-in"></i>
                                    </span> 
                                    <span  v-if="!disabled"  class="el-upload-list__item-delete" @click="handleRemove(file)">
                                        <i class="el-icon-delete"></i>
                                    </span>
                                </span>
                            </div>
                        </el-upload>
                        <el-dialog :modal-append-to-body='false' :modal="false"  :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>    
                </div>  
                <div style="width:43%;float:left">
                    <p class="titleInfo" style="margin-top:-10px;margin-bottom:0px;">推广范围</p>  
                    <el-cascader v-model.trim="promoteArea" style="width:100%;" filterable clearable :options="select5.option" :props="{ multiple: true }" collapse-tags></el-cascader>
                 
                </div> 
                </div> 
                <div style="width:100%;height: 260px;">
                    <div style="width:56%;float:left;margin-right:1%;">
                    <p class="titleInfo" style="margin-top:-10px;margin-bottom:0px;">二确信息</p> 
                    <el-button style="float:right;margin-top:-30px;height:30px;background:#0094d8;border:none;border-left:1px solid #fff" type="danger" size="small" @click="addSureImg">添加其它图片</el-button> 
                    
                    <quill-editor ref="myTextEditor" style=""  v-model="form1.sureContent" :options="editorOption"></quill-editor>
                    <!--  <div id="input_box" contenteditable="true"></div>-->
                    </div>  
                    
                    <div style="width:43%;float:left;">
                    <p class="titleInfo" style="margin-top:-10px;margin-bottom:0px;">推广要求</p> 
                    <quill-editor ref="myTextEditor" style=""  v-model="form1.promoteRequire" :options="editorOption"></quill-editor>
                    <!--  <div id="input_box" contenteditable="true"></div>-->
                    </div> 
                    
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button  @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>

        <!-- 编辑 -->
        <el-dialog :close-on-click-modal="false" title="编辑组品" :visible.sync="editVisible" :modal-append-to-body='false'    width="800px" top="30px" >
            <el-form ref="form2" :model="form" label-width="90px" @submit.native.prevent="saveEdit"> 
                 
                <div>
                <p class="titleInfo" style="margin-top:-10px">产品信息</p>  
                <el-form-item label="产品分类" required style="width:28%;display:inline-block;margin-top:-10px ">
                     <el-select v-model.trim="form2.goodsType" placeholder="请选择产品分类"   > 
                            <el-option v-for="item in select2.option" :key="item.id" :label="item.optVal" :value="item.optKey" />    
                    </el-select>  
                </el-form-item>  
                 <el-form-item label="产品来源" required style="width:28%;display:inline-block;margin-top:-10px">
                     <el-select v-model.trim="form2.goodsFrom" placeholder="请选择产品来源" style="width:100%"   > 
                        <el-option v-for="item in select3.option" :key="item.id" :label="item.optVal" :value="item.optKey" />  
                    </el-select>  
                </el-form-item>  
                <el-form-item label="产品名称" required style="width:44%;display:inline-block;margin-top:-10px" >
                    <el-input  type="text" placeholder="填写产品名称" style="width:100%;" v-model.trim="form2.goodsName"  ></el-input>
                </el-form-item>  
                <el-form-item label="商品资费" required style="width:28%;display:inline-block;  margin-top:-15px" >
                    <el-input placeholder="商品资费"  style="width:100px;"  v-model.trim="form2.goodsRate"   oninput="value=value.replace(/[^0-9.]/g,'')"  ></el-input> 元
                </el-form-item>   
                <el-form-item label="计费通道" required style="width:28%;display:inline-block;  margin-top:-10px">
                     <el-select v-model.trim="form2.isp" placeholder="请选择"   > 
                        <el-option label="移动" value="1" />
                        <el-option label="联通" value="2" />
                        <el-option label="电信" value="3" /> 
                        <el-option label="自收款" value="0" /> 
                        <el-option label="代收款" value="9" />    
                    </el-select>  
                </el-form-item>    
                <template > 
                    <el-form-item label="产品佣金" required style="width:40%;display:inline-block; margin-top:-15px" >
                        <el-input   v-model.trim="form2.goodsCom" placeholder="单位元" style="width:120px; "  oninput="value=value.replace(/[^0-9.]/g,'')" ></el-input>
                        元
                    </el-form-item> 
                </template>   
                <el-form-item label="冷静时长" style="width:28%;display:inline-block;margin-top:-10px ">
                     <el-input  v-model.trim="form2.coolTime"   placeholder="单位分钟" style="width:85px "   oninput="value=value.replace(/[^0-9.]/g,'')"   ></el-input>
                        分钟
                </el-form-item>  
                 <el-form-item label="办理年龄" style="width:28%;display:inline-block;margin-top:-10px">
                     <el-input  v-model.trim="form2.ageRange"   placeholder="办理年龄" style="width:100%;"   ></el-input>
                     
                </el-form-item>  
                <el-form-item label="投放时间" required style="width:44%;display:inline-block;margin-top:-10px" >
                    <el-time-select v-model="form2.promoteStart" value-format="HH:mm" style="width:120px;"  placeholder="开始时间" :picker-options="{  start: '00:00', step: '00:30', end: '24:00' }"></el-time-select>
                    <el-time-select v-model="form2.promoteEnd" value-format="HH:mm" style="width:120px;"   placeholder="结束时间" :picker-options="{  start: '00:00', step: '00:30', end: '36:00' }"></el-time-select>
                </el-form-item>   
                 <el-form-item label="订购条款" style="width:56%;display:inline-block; margin-top:-10px" >
                   <el-select multiple v-model.trim="goodsRead2" placeholder="请选择" style="width:100%"   filterable clearable  > 
                        <el-option v-for="item in select7.option" :key="item.id" :label="item.optVal" :value="item.optKey" />  
                    </el-select>   
                </el-form-item>  
                <el-form-item label="组品逻辑" required style="width:44%;display:inline-block;  margin-top:-10px">
                    <el-select v-model.trim="form2.channelCode" placeholder="请选择组品逻辑" style="width:100%;;margin-top:-10px" class="handle-select mr10"> 
                        <el-option v-for="item in select6.option" :key="item.id" :label="item.optVal" :value="item.optKey" />    
                    </el-select>
                </el-form-item>   
                <el-form-item label="产品标签"  required style="width:100%;display:inline-block; margin-top:-10px" >
                   <el-select multiple  collapse-tags v-model.trim="goodsTag2" placeholder="请选择" style="width:100%"  filterable clearable > 
                        <el-option v-for="item in select4.option" :key="item.id" :label="item.optVal" :value="item.optKey" />  
                    </el-select>   
                </el-form-item>  
                 
                <div style="width:56%;float:left;margin-right:1%; ">
                    <p class="titleInfo" style="margin-top:-10px;margin-bottom:0px;">落地页内容</p> 
                    <el-button style="float:right;margin-top:-30px;height:30px;background:#0094d8;border:none;border-left:1px solid #fff" type="danger" size="small" @click="addContent">添加富文本内容</el-button>
                    <el-upload action="#" list-type="picture-card" :file-list="fileList" :on-remove="handleRemove" :on-change="handleChange" multiple="true" :limit="9" :on-exceed="overMaxImg" :auto-upload="false" >
                        <i slot="default" class="el-icon-plus" tip="点击或拖动上传"></i>
                            <div slot="file" slot-scope="{file}">
                                <img class="el-upload-list__item-thumbnail" :src="file.url" alt=""  >
                                <span class="el-upload-list__item-actions"> 
                                    <span class="el-upload-list__item-preview"  @click="handlePictureCardPreview(file)">
                                        <i class="el-icon-zoom-in"></i>
                                    </span> 
                                    <span  v-if="!disabled"  class="el-upload-list__item-delete" @click="handleRemove(file)">
                                        <i class="el-icon-delete"></i>
                                    </span>
                                </span>
                            </div>
                        </el-upload>
                        <el-dialog :modal-append-to-body='false' :modal="false"  :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>    
                </div>  
                <div style="width:43%;float:left">
                    <p class="titleInfo" style="margin-top:-10px;margin-bottom:0px;">推广范围</p>  
                    <el-cascader v-model.trim="promoteArea2" style="width:100%;" filterable clearable :options="select5.option" :props="{ multiple: true }" collapse-tags></el-cascader>
                 
                </div> 
                </div> 
                <div style="width:100%;height: 260px;">
                    <div style="width:56%;float:left;margin-right:1%;">
                    <p class="titleInfo" style="margin-top:-10px;margin-bottom:0px;">二确信息</p> 
                    <el-button style="float:right;margin-top:-30px;height:30px;background:#0094d8;border:none;border-left:1px solid #fff" type="danger" size="small" @click="addSureImg2">修改其它图片</el-button>
                    
                    <quill-editor ref="myTextEditor" style=""  v-model="form2.sureContent" :options="editorOption"></quill-editor>
                    <!--  <div id="input_box" contenteditable="true"></div>-->
                    </div> 
                    <div style="width:43%;float:left;">
                    <p class="titleInfo" style="margin-top:-10px;margin-bottom:0px;">推广要求</p> 
                    <quill-editor ref="myTextEditor" style=""  v-model="form2.promoteRequire" :options="editorOption"></quill-editor>
                    <!--  <div id="input_box" contenteditable="true"></div>-->
                    </div>  
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">{{ isSubmitting ? '保存中...' : '保 存' }}</el-button>
            </span>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" title="落地页富文本" :visible.sync="contentVisible" :modal-append-to-body='false'  top="50px" width="620px">
            <div style="height:500px">
             <el-button :type="saveContent==0?'primary':'danger'" style="position:absolute;top:55px;right:30px;"  @click="saveText">{{saveContent==0?'保存':'取消保存'}}</el-button>
            <quill-editor ref="myTextEditor" class='contentHei' style="height:450px;margin-top:-15px;"  v-model="contentVal" :options="editorOption"></quill-editor> 
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="添加其它图片" :visible.sync="sureImgVisible" :modal-append-to-body='false'   top="150px" width="630px">
            <ul class="chm-imgUl">
                <li class="chm-imgLi">
                    <img :src="form1.sureImg" style="width: 100px;height: 160px;border:1px solid #ddd">
                    <i class="el-icon-lx-add chm-imgFag" ></i>
                    <div class="chm-imgDiv">
                        <input type="file" name="image" accept="image/*" @change="addImage" class="chm-imgInput" />
                    </div> 
                    <span class="chm-imgTip">订购中图片</span> 
                </li>
                 <li class="chm-imgLi">
                    <img :src="form1.img1" style="width: 100px;height: 160px;border:1px solid #ddd">
                    <i class="el-icon-lx-add chm-imgFag" ></i>
                    <div class="chm-imgDiv">
                        <input type="file" name="image" accept="image/*" @change="addImage1" class="chm-imgInput" />
                    </div>
                    <span class="chm-imgTip">产品主图</span> 
                </li>
                 <li class="chm-imgLi">
                    <img :src="form1.img2" style="width: 100px;height: 160px;border:1px solid #ddd">
                    <i class="el-icon-lx-add chm-imgFag" ></i>
                    <div class="chm-imgDiv">
                        <input type="file" name="image" accept="image/*" @change="addImage2" class="chm-imgInput" />
                    </div>
                    <span class="chm-imgTip">落地页图片</span> 
                </li>
                <li class="chm-imgLi">
                    <img :src="form1.img3" style="width: 100px;height: 160px;border:1px solid #ddd">
                    <i class="el-icon-lx-add chm-imgFag" ></i>
                    <div class="chm-imgDiv">
                        <input type="file" name="image" accept="image/*" @change="addImage3" class="chm-imgInput" />
                    </div>
                    <span class="chm-imgTip">二确页图片</span> 
                </li>
                <label class="label2" style="margin-left:20px;margin-top:20px;width:100px;">权益领取链接</label> 
                <el-input  type="text" placeholder="权益领取跳转链接"  v-model.trim="form1.fb1" class="handle-input" style="width:280px;"></el-input>
            </ul> 
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="修改其它图片" :visible.sync="sureImgVisible2" :modal-append-to-body='false'  top="150px" width="620px">
            <ul class="chm-imgUl">
                <li class="chm-imgLi">
                    <img :src="form2.sureImg" style="width: 100px;height: 160px;border:1px solid #ddd">
                    <i class="el-icon-lx-add chm-imgFag" ></i>
                    <div class="chm-imgDiv">
                        <input type="file" name="image" accept="image/*" @change="changeImage" class="chm-imgInput" />
                    </div> 
                    <span class="chm-imgTip">订购中图片</span> 
                </li>
                 <li class="chm-imgLi">
                    <img :src="form2.img1" style="width: 100px;height: 160px;border:1px solid #ddd">
                    <i class="el-icon-lx-add chm-imgFag" ></i>
                    <div class="chm-imgDiv">
                        <input type="file" name="image" accept="image/*" @change="changeImage1" class="chm-imgInput" />
                    </div>
                    <span class="chm-imgTip">产品主图</span> 
                </li>
                 <li class="chm-imgLi">
                    <img :src="form2.img2" style="width: 100px;height: 160px;border:1px solid #ddd">
                    <i class="el-icon-lx-add chm-imgFag" ></i>
                    <div class="chm-imgDiv">
                        <input type="file" name="image" accept="image/*" @change="changeImage2" class="chm-imgInput" />
                    </div>
                    <span class="chm-imgTip">落地页图片</span> 
                </li>
                <li class="chm-imgLi">
                    <img :src="form2.img3" style="width: 100px;height: 160px;border:1px solid #ddd">
                    <i class="el-icon-lx-add chm-imgFag" ></i>
                    <div class="chm-imgDiv">
                        <input type="file" name="image" accept="image/*" @change="changeImage3" class="chm-imgInput" />
                    </div>
                    <span class="chm-imgTip">二确页图片</span> 
                </li> 
                <label class="label2" style="margin-left:20px;margin-top:20px;width:100px;">权益领取链接</label> 
                <el-input  type="text" placeholder="权益领取跳转链接"  v-model.trim="form2.fb1" class="handle-input" style="width:280px;"></el-input>
            </ul> 
        </el-dialog> 
        <el-dialog :close-on-click-modal="false" title="产品配置" :modal-append-to-body='false' :visible.sync="goodsConfigVisible" top="50px"  width="500px">
            <el-form ref="form" :model="formL" label-width="80px">    
                    <span class="label-span"  style="display:block;" >
                        <label class="label">系统折算</label> 
                        <el-radio-group  v-model.trim="form4.orderSuccess" > 
                            <el-radio-button label="0">不折算</el-radio-button> 
                            <el-radio-button label="1">折算</el-radio-button> 
                        </el-radio-group>  
                    </span>    
                    <span class="label-span" style="display:block;margin-top:10px " >
                        <label class="label">结算指标</label> 
                        <el-checkbox-group v-model="successIndexs"  size="mini" style=" display:inline-block;margin-left:15px;">
                            <el-checkbox label="9" style=" display:inline-block;padding:0;margin-right:10px;">订购成功</el-checkbox>
                            <el-checkbox label="6" style=" display:inline-block;padding:0;margin-right:10px;" >回填成功</el-checkbox>
                            <el-checkbox label="-1" style=" display:inline-block;padding:0;margin-right:10px;" >订购失败</el-checkbox>
                        </el-checkbox-group>
                    </span>    
                    <span class="label-span"  style="display:block;margin-top:10px ">
                        <label class="label">风控类型</label> 
                        <el-radio-group  v-model.trim="form4.riskLevel"  >
                            <el-radio-button label="0">关闭风控</el-radio-button> 
                            <el-radio-button label="1">资源风控</el-radio-button> 
                            <el-radio-button label="2">产品风控</el-radio-button> 
                        </el-radio-group>   
                    </span>   
                    <span class="label-span" style="display:block;margin-top:10px " v-if="form4.riskLevel==1 || form4.riskLevel==2" >
                        <label class="label">风控指标</label> 
                        <el-checkbox-group v-model="riskIndexs"   size="mini" style=" display:inline-block;margin-left:15px;padding:0">
                            <el-checkbox label="9"  style=" display:inline-block;padding:0;margin-right:10px;">订购成功</el-checkbox>
                            <el-checkbox label="6"  style=" display:inline-block;padding:0;margin-right:10px;">回填成功</el-checkbox>
                            <el-checkbox label="-1" style=" display:inline-block;padding:0;margin-right:10px;">订购失败</el-checkbox>
                        </el-checkbox-group>
                    </span>    
                    <span class="label-span" style="display:block;margin-top:10px" v-if="form4.riskLevel==1 || form4.riskLevel==2">
                        <label class="label">风控参数</label> 
                        <el-input  v-model.trim="form4.riskTotal"  oninput="value=value.replace(/[^\d]/g,'')" placeholder="整体风控值" style="width:115px;" class="handle-input mr10"></el-input>
                        <el-input  v-model.trim="form4.riskRate" oninput="value=value.replace(/[^\d]/g,'')" placeholder="转化率要求" style="width:115px;" class="handle-input"></el-input>%
                    </span>  
                    <span class="label-span" style="display:block;margin-top:10px ">
                        <label class="label">产品类型</label> 
                        <el-radio-group  v-model.trim="form4.isPj"  > 
                            <el-radio-button label="0">接口产品</el-radio-button> 
                            <el-radio-button label="1">页面产品</el-radio-button>  
                            <el-radio-button label="2">官方二确</el-radio-button>   
                            <el-radio-button label="3">破解产品</el-radio-button>      
                        </el-radio-group>   
                    </span> 
                    <span class="label-span" style="display:block;margin-top:10px" v-if="form4.isPj==2">
                        <label class="label">破解产品编码</label> 
                        <el-input v-model.trim="form4.pjCode" oninput="value=value.replace(/[^\d]/g,'')"  placeholder="破解产品编码" style="width:237px;"></el-input>
                    </span>  
                    <span class="label-span" style="display:block;margin-top:10px ">
                        <label class="label">产品限量</label> 
                        <el-radio-group  v-model.trim="form4.limitType" > 
                            <el-radio-button label="0">不设限量</el-radio-button> 
                            <el-radio-button label="1">资源限量</el-radio-button> 
                            <el-radio-button label="2">产品限量</el-radio-button>  
                        </el-radio-group>  
                    </span>
                    <span class="label-span" style="display:block;margin-top:10px" v-if="form4.limitType==1 || form4.limitType==2">
                        <label class="label">总体限单</label> 
                        <el-input v-model.trim="form4.limitNum" oninput="value=value.replace(/[^\d]/g,'')"  placeholder="总体限单数量" style="width:237px;"></el-input>
                    </span>   
                    <span class="label-span" style="display:block;margin-top:10px" >
                        <label class="label">上游到量提示</label> 
                        <el-input v-model.trim="form4.limitInfo" placeholder="上游接口返回信息中包含到量提示进行到量关闭" style="width:237px;"></el-input>
                    </span>   
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="aesIdVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveGoodsConfig">确 定</el-button>
            </span>
        </el-dialog> 
        <el-dialog :close-on-click-modal="false" title="进单屏蔽" :modal-append-to-body='false' :visible.sync="bindConfigVisible" top="50px"   width="880px">
            <el-form ref="form" :model="formL" label-width="80px" style="height:400px;overflow-y:scroll">     
                <div style="display:block;" >
                    <label class="label">屏蔽投放平台 </label> 
                    <el-input  type="textarea" rows="2" v-model.trim="form4.platform" placeholder="屏蔽的投放平台，多个平台以英文逗号隔开" style="width:100%;"></el-input>
                </div>  
                <div style="display:block;margin-top:10px" >
                    <label class="label">允许投放平台 </label> 
                    <el-input  type="textarea" v-model.trim="form4.onlyPlatform" placeholder="仅允许投放的平台，多个平台以英文逗号隔开" style="width:100%;"></el-input>
                </div>  
                  <span style="display:block;margin-top:10px" >
                    <label class="label">屏蔽触点 </label> 
                    <el-input  type="textarea"  rows="2"  v-model.trim="form4.contact" placeholder="屏蔽触点，多个触点以英文逗号隔开" style="width:100%;"></el-input>
                </span> 
                <span style="display:block;margin-top:10px" >
                    <label class="label">屏蔽 I P </label> 
                    <el-input  type="textarea" v-model.trim="form4.userIp" placeholder="屏蔽IP，多个IP以英文逗号隔开" style="width:100%;"></el-input>
                </span>
                <span style="display:block;margin-top:10px" >
                    <label class="label">屏蔽包名</label> 
                    <el-input type="textarea"  rows="5"  v-model.trim="form4.appPackage" placeholder="屏蔽包名，多个包名以英文逗号隔开" style="width:100%;"></el-input>
                </span>   
                <span style="display:block;margin-top:10px" >
                    <label class="label">屏蔽号码 </label> 
                    <el-input  type="textarea"  rows="5"  v-model.trim="form4.phone" placeholder="屏蔽号码，多个号码以英文逗号隔开" style="width:100%;"></el-input>
                </span> 
                 
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="aesIdVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveGoodsBind">确 定</el-button>
            </span>
        </el-dialog> 

        <el-dialog  :title="linkTitle" :modal-append-to-body='false' :visible.sync="linkVisible" :width="wid" top="30px" height="100%" > 
            <iframe :src="linkUrl"  frameborder="0" style="margin-top:-15px;" width="100%" height="600px"></iframe> 
        </el-dialog> 
        <el-drawer :title="goodsName+' - 渠道分配'" :visible.sync="memConfigVisible" direction="ttb" :append-to-body='true'  height="100%">
            <v-content2></v-content2>
        </el-drawer>
        <el-drawer :title="goodsName+' - 组品配置'" :visible.sync="sonConfigVisible" direction="ttb" :append-to-body='true'  height="100%">
            <v-content3></v-content3>
        </el-drawer>

        <el-dialog :close-on-click-modal="false" title="分省配置" :modal-append-to-body='false' :visible.sync="provinceVisible" top="50px"  width="980px">
            <div  style="border: 1px dashed #409EFF;background:#ecf5ff;padding:15px 10px;"> 
                    <span class="label-span">
                        <label class="label2">省份名称</label> 
                        <el-input v-model.trim="query3.oname" placeholder="省份名称" style="width:120px;" class="handle-input mr10"></el-input> 
                    </span>      
                    <el-button type="success" size="small" @click="handleSearch3">搜索</el-button>
                    <el-button type="warning" size="small" @click="refreshSearch3">重置</el-button> 
                    <el-tooltip  content="点击解开编辑权限" placement="top">
                        <i style="color:#fff;font-size:25px;vertical-align:middle;cursor:pointer;color: #409eff;float:right;margin-right:20px;" class='el-icon-edit-outline'  @click="setConfigEdit()"></i>
                    </el-tooltip>

                <el-table :data="cityData" stripe="true" size="mini" border class="table" ref="multipleTable" header-cell-class-name="table-header"  
                v-loading="loading4" element-loading-text="请稍等..."  style="height:500px;overflow-y:scroll;margin-top:15px">  
                    <el-table-column prop="oname"  width="160" align="left" label="省份名称"> </el-table-column>  
            
                    <el-table-column prop="gid"  min-width="200" align="left" label="到量提示词">
                        <template slot-scope="scope" >
                            <p style="font-size:13px; "> 
                               <el-input class='inputStyle' v-model.trim="scope.row.numInfo" :disabled="config.edit" @change="setCityVal(scope.row)" placeholder="到量提示词"  style="width:100%" >
                                </el-input>
                            </P>     
                        </template>    
                    </el-table-column>    
                    <el-table-column prop="channelComType" min-width="280" align="center" label="投放时间">
                        <template slot-scope="scope" >
                            <p style="font-size:13px;"> 
                                <el-time-select v-model="scope.row.promoteStart" @change="setCityVal(scope.row)" :disabled="config.edit" value-format="HH:mm" style="width:120px;"  placeholder="开始时间" :picker-options="{  start: '00:00', step: '00:30', end: '24:00' }"></el-time-select>
                                <el-time-select v-model="scope.row.promoteEnd" @change="setCityVal(scope.row)" :disabled="config.edit" value-format="HH:mm" style="width:120px;"   placeholder="结束时间" :picker-options="{  start: '00:00', step: '00:30', end: '36:00' }"></el-time-select>
                
                            </p>   
                        </template>
                    </el-table-column>   
                    <el-table-column prop="status" align="center" width="80" label="到量状态">
                        <template slot-scope="scope" > 
                            <p style="font-size:13px; "> 
                                <el-tooltip :content="scope.row.numStatus=='1'?'已到量':'未到量'" placement="top">
                                    <el-switch @change="setCityStatus(scope.row)" 
                                        v-model="scope.row.numStatus"
                                        active-color="red"
                                        inactive-color="#67C23A"
                                        active-value="1"
                                        inactive-value="0">
                                    </el-switch>
                                </el-tooltip>  
                            </p>    
                        </template>  
                    </el-table-column>    
                    <el-table-column prop="numTime" width="140" align="left" label="到量时间">
                        <template slot-scope="scope" >
                            <p style="font-size:13px;" v-if="scope.row.numStatus=='1'"> 
                                 {{scope.row.numTime}}
                            </p>   
                        </template>
                    </el-table-column>  
            
                </el-table>   
            </div> 
        </el-dialog> 
        
    </div>
 
</template> 

<script>
import $ from 'jquery' ;  
import {   
    fetchGroupData,fetchData3,setLimitConfig,changeGive,fetchSelect,uploadDetailPlain,saveForm,downOrderExcel,changeForm,getGoodsDetail,changeStatus,handleCopy,handDelete,handDeleteBatch, 
    getGoodsConfig,saveGoodsConfig,getGoodsBind,saveGoodsBind

} from '../../api/comGoods';   
import {getCityData,changeCityVal,changeCityStatus} from '../../api/comGoodsMemConfig'; 
import {fetchSelect as fetchSelect1} from '../../api/channelType';  //资源分类
import {fetchSelect as fetchSelect2} from '../../api/goodsType';  //产品分类
import {fetchSelect as fetchSelect3} from '../../api/goodsFrom';  //产品来源
import {fetchSelect as fetchSelect4} from '../../api/goodsTag';  //产品标签
import {fetchTreeSelect as fetchSelect5} from '../../api/city';  //推广省份 
import {fetchSelect as fetchSelect6} from '../../view/channel/channel';  //资源名称
import {fetchSelect as fetchSelect7} from '../../api/goodsRead';  //订购条款  
import 'quill/dist/quill.core.css'; 
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import Quill from 'quill'
import { quillEditor } from 'vue-quill-editor';
import { ImageDrop } from 'quill-image-drop-module' // 图片拖动组件引用
import ImageResize from 'quill-image-resize-module' // 图片缩放组件引用
Quill.register('modules/imageDrop', ImageDrop) // 注册
Quill.register('modules/imageResize', ImageResize) // 注册 
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
  //["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
  [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
  //[{ 'header': 1 }, { 'header': 2 }],
  //[{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
  //[{ indent: "-1" }, { indent: "+1" }],
  //[{ size: ['small', false, 'large', 'huge']}], // 配置字号
  [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
  //[{ font: []}], //显示字体选择
  [{ align: [] }], // 对齐方式-----
 // ["clean"], // 清除文本格式-----
  ['link', 'image'],// ['link', 'image', 'video'], // 链接、图片、视频-----
]; 
import bus from '../common/bus'; 
import vContent1 from './ComGoodsLimit.vue';
import vContent2 from '../../view/goods/ComGoodsMemConfig.vue';
//import vContent2 from './ComGoodsMemConfig2.vue';
import vContent3 from './ComGoodsSonConfig.vue';
export default {

    data() {
        return {  
            editorOption: { 
                placeholder: '不超过400个字',
                // 主题
                theme: "snow",
                modules: {
                    imageDrop: true,      //图片拖拽
                    imageResize: {          //放大缩小
                    displayStyles: {
                        backgroundColor: "black",
                        border: "none",
                        color: "white"
                        },
                        modules: ["Resize", "DisplaySize", "Toolbar"]
                    }, 
                    toolbar: toolbarOptions,
                },
            }, 
            isSubmitting: false, // 是否正在提交
            fag:'0',
            goodsCode:'',
            Timeout:'', 
            Ishow:'el-icon-caret-bottom',
            wid:'400px', 
            topSet:'50px',
            imgUrl:'',
            linkUrl:'',
            linkTitle:'',
            goodsName:'',
            orderDis:true,
            config:{
                wid:'800px',
                top:'50px',
                edit:true,
            }, 
            successIndexs:[],
            riskIndexs:[],
            provinceVisible:false,
            bindConfigVisible:false,
            goodsConfigVisible:false,
            memConfigVisible:false,
            sonConfigVisible:false,
            contentVisible:false,
            sureImgVisible:false, 
            sureImgVisible2:false, 
            saveContent:'0',
            contentVal:'',
            infoVisible:false,
            loading:false,
            loading2:false,
            loading3:false,
            loading4:false,
            limitVisible:false,
            showDiv:true,
            linkVisible:false,
            show:'v',
            loadingTitle:'正在初始化数据',
            cropImg:require('/public/base-img.png'), 
            fileList:[],
            fileList2:[],
            detailImg:[], 
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            skuVisible:false, 
            select:{ option:'',  },  
            select1:{ option:'',  },  
            select2:{ option:'',  },  
            select3:{ option:'',  }, 
            select4:{ option:'',  },  
            select5:{ option:'',  },  
            select6:{ option:'',  },  
            select7:{ option:'',  },  
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            }, 
            query2: { 
                pageIndex: 1,
                pageSize: 10,  
                goodsCode:'',
            }, 
            query3: { 
                pageIndex: 1,
                pageSize: 10,  
                goodsCode:'',
                level:'1',
            }, 
            imgHeight:'600',
            tableData: [],
            tableData2: [], 
            cityData: [], 
            skuCodes:[],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            imgVisible:false,
            addVisible:false,
            detailVisible:false,
            pageTotal: 0,
            pageTotal2:0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {  
                 smsSize:0,
                 goodsComType:'1',
                 channelComType:'1',
                 groupType:'1',
                 sureImg:null,
                 img1:null,
                 img2:null,
                 img3:null,
            },
            promoteArea:[],
            goodsRead:[],
            goodsTag:[],
            promoteArea2:[],
            goodsRead2:[],
            goodsTag2:[],
            form2:{masterImg:'',fileList:[], sureImg:'',
                 img1:'',
                 img2:'',
                 img3:'',},
            form3:{},
            form4:{},
            idx: -1,
            id: -1
        };
    },
    components: {
        quillEditor,
        vContent1,
        vContent2,
        vContent3
    },
    created() { 
    },
    //页面加载方法
    mounted: function () { 
        //获取下拉框数据 
        //查询列表
        this.getData();  
        this.getSelect();  
        this.getSelect1();  
        this.getSelect2();  
        this.getSelect3(); 
        this.getSelect4(); 
        this.getSelect5();
        this.getSelect7(); 
        this.getSelect6(''); 
    }, 
    methods: { 
        setEdit(){ 
            if(this.orderDis){
                this.orderDis = false;
            }else{
                this.orderDis = true;
            } 
        },
        setConfigEdit(){ 
            if(this.config.edit){
                this.config.edit = false; 
            }else{
                this.config.edit = true;
               
            }
        },
        numFilter(value) { 
            const realVal = parseFloat(value).toFixed(2); 
            return realVal; 
        }, 
        
        fullOper(){ 
            if(this.widthSet=='450px'){ 
                this.widthSet="100%";
                this.topSet = "0";
                this.heightSet = "100%"; 
            }else{
                this.widthSet="450px";
                this.topSet = "50px";
                this.heightSet = "60%";
            } 
        }, 
        showLink1(row){
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid'); 
            this.linkUrl = window.location.protocol+"//"+host+"/h5/goodsDoc/2/"+row.goodsCode;
            this.linkTitle = row.goodsName;
            this.wid = "400px";
            this.linkVisible = true;
        },
        showLink2(row){
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid'); 
            this.linkUrl = window.location.protocol+"//"+host+"/h5/cl/code2_2/"+row.goodsCode;
            this.linkTitle = row.goodsName;
            this.wid = "360px";
            this.linkVisible = true;
        },
        showLink3(row){
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid'); 
            this.linkUrl = window.location.protocol+"//"+host+"/h5/cl/cs_2/"+row.goodsCode;
            this.linkTitle = row.channelName+"-"+row.goodsName;
            this.wid = "1000px";
            this.linkVisible = true;
        },
        saveText(){
            if(this.saveContent == "0"){
               this.$set(this, 'saveContent','1'); 
               this.$notify({ title: '成功', message: '已成功保存落地页富文本内容',duration: 1000, type: 'success' });
            }else{
               this.$set(this, 'saveContent','0'); 
                this.$notify({ title: '成功', message: '已取消保存落地页富文本内容',duration: 1000, type: 'success' });
            } 
            
        },
        bindConfig(row){
            getGoodsBind(row).then(res => {   
                if(res.code=='200'){  
                    this.form4 = res.data; 
                    this.bindConfigVisible = true;
                }else{
                    this.$message.error(res.message); 
                }
            });  
        },
        goodsConfig(row){
            getGoodsConfig(row).then(res => {   
                if(res.code=='200'){  
                    this.form4 = res.data;
                    this.successIndexs = this.form4.successIndex.split(","); 
                    this.riskIndexs = this.form4.riskIndex.split(","); 
                    this.goodsConfigVisible = true;
                }else{
                    this.$message.error(res.message); 
                }
            });  
        },
        saveGoodsConfig(){ 
            if((this.form4.limitType==1 || this.form4.limitType==2) && !this.form4.limitNum){
                this.$message.error("请填写整体限单数量"); 
                return;
            }
            if((this.form4.riskLevel==1 || this.form4.riskLevel==2) && !this.form4.riskTotal){
                this.$message.error("请填写整体风控值"); 
                return;
            }
            if((this.form4.riskLevel==1 || this.form4.riskLevel==2) && !this.form4.riskRate){
                this.$message.error("请填写转化率邀请"); 
                return;
            }
            if(this.form4.isPj==3 && !this.form4.pjCode){
                this.$message.error("请填写原产品编码"); 
                return;
            }
            if(this.successIndexs=='' || this.successIndexs==null || this.successIndexs==undefined ){
                this.$message.error("请勾选转结算指标"); 
                return;
            } 
            this.form4.successIndex =  this.successIndexs.join();
            if(this.form4.successIndex.charAt(0) === ','){
                this.form4.successIndex = this.form4.successIndex.substring(1);
            } 
            this.form4.riskIndex =  this.riskIndexs.join();
            if(this.form4.riskIndex.charAt(0) === ','){
                this.form4.riskIndex = this.form4.riskIndex.substring(1);
            } 
            saveGoodsConfig(this.form4).then(res => {   
                if(res.code=='200'){    
                    this.goodsConfigVisible = false;
                    this.$message.success("产品配置修改成功"); 
                }else{
                    this.$message.error(res.message); 
                }
            });  
        },
        saveGoodsBind(){  
            saveGoodsBind(this.form4).then(res => {   
                if(res.code=='200'){    
                    this.bindConfigVisible = false;
                    this.$message.success("产品进单屏蔽修改成功"); 
                }else{
                    this.$message.error(res.message); 
                }
            });  
        },
        limitConfig(row){  
            this.$confirm("确认对"+row.goodsName+"-"+"进行限单数量调整？") .then(() => { 
                this.goodsName = row.goodsName;
                this.limitVisible = true;
                setTimeout( () => {
                    bus.$emit('limit-method', row);
                }, 500)
                
                //this.$refs.child.limitConfigSet(row);
            });  
        },   
        setCityVal(row){
            changeCityVal(row).then(res => {   
                if(res.code=='200'){ 
                    this.$notify({ title: '成功', message: row.oname+' 设置成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失败', message: row.oname+' 设置失败：'+res.message,duration: 5000, type: 'error' }); 
                }
            });
        },
        setCityStatus(row){
            var tips ;
            var content;
            if(row.numStatus=='0'){ 
                row.numStatus='1';
                tips = "关闭到量"; 
            }else{ 
                row.numStatus = '0';
                tips = "设置到量"; 
            }
            this.$confirm('确认对《'+row.oname+"》"+tips+'吗', '提示', {
                type: 'warning'
            }).then(() => {
                if(row.numStatus=='0'){ 
                    row.numStatus='1' 
                }else{ 
                    row.numStatus='0' 
                }
                row.memId = row.mid;
                changeCityStatus(row).then(res => {   
                    if(res.code=='200'){ 
                        this.getCityData();
                        this.$notify({ title: '成功', message: row.oname+' 设置到量状态成功',duration: 1000, type: 'success' });
                    }else{
                        if(row.numStatus=='0'){ 
                            row.numStatus='1' 
                        }else{ 
                            row.numStatus='0' 
                        }
                        this.$notify({ title: '失败', message: row.oname+' 设置到量状态失败：'+res.message,duration: 5000, type: 'error' }); 
                    }
                });
            }); 
        },
        memConfig(row){   
            this.goodsName = row.goodsName;
            this.memConfigVisible = true;
            setTimeout( () => {
                bus.$emit('config-set', row);
            }, 500)  
        },
        sonConfig(row){   
            this.goodsName = row.goodsName;
            this.sonConfigVisible = true;
            setTimeout( () => {
                bus.$emit('config-son', row);
            }, 500)  
        },
        provinceConfig(row){   
            this.config.edit = true;
            this.$set(this.config, 'edit',true);   
            // 获取列表数据   
            this.query3.goodsCode = row.goodsCode; 
            this.getCityData();
            this.provinceVisible = true; 
            
        },

        getCityData(){
            this.loading4 = true;
            getCityData(this.query3).then(res => {  
                this.loading4 = false;
                if(res.code=='200'){ 
                    this.cityData = res.data; 
                }else{
                    this.cityData = [];  
                } 
                
            });  
        },

        LimitNumChange(){ 
            this.changeGiveNum(); 
        }, 
        giveTypeChange(index,row){ 
            if(this.form4.limitNum=='' || this.form4.limitNum=='-1' ){
                this.$message.error("请先输入产品限单数量");
                if(row.giveType==1){
                    this.$set(this.tableData2[index], 'giveType','2');     
                }else{
                    this.$set(this.tableData2[index], 'giveType','1');     
                } 
                return;
            }  
            this.$set(this.tableData2[index], 'giveType',row.giveType);  
            //后台计算单量限制  
            this.changeGiveNum(); 
        }, 
        changeGiveNum(){  
            if(this.form4.limitNum=='' || this.form4.limitNum=='-1' ){
                this.$message.error("请先输入产品限单数量"); 
                return;
            }
            var num = 0;
            for(var i=0;i<this.tableData2.length;i++){
                if(this.tableData2[i].giveType==1){
                    num+=parseInt(this.tableData2[i].giveNum);
                }
            } 
            if(this.form4.limitNum<num){
                this.$message.error("当前定额总量小于产品限单数量！");
                return;
            }
            //系统后台计算  
            var limitConfig = [];
            var limitSet = [];
            for(var i=0;i<this.tableData2.length;i++){
                if(this.tableData2[i].giveType==1){ 
                    limitConfig.push(this.tableData2[i]);
                } 
                limitSet.push(this.tableData2[i]);
                 
            }  
            if(limitConfig && limitConfig.length>0){
                this.form4.limitConfig = JSON.stringify(limitConfig);
            } 
            if(limitSet && limitSet.length>0){
                this.form4.limitSet = JSON.stringify(limitSet);
            } 
            setLimitConfig(this.form4).then(res => {   
                if(res.code=='200'){  
                    this.$notify({ title: '成功', message: '限单设置成功',duration: 1000, type: 'success' });
                    for(var i=0;i<this.tableData2.length;i++){
                        if(this.tableData2[i].giveType==2){
                            this.getData();
                            num+=parseInt(this.tableData2[i].giveNum=res.data);
                        }
                    } 
                }else{
                     this.$notify({ title: '失败', message: '限单设置失败：'+res.message,duration: 3000, type: 'error' });
                }
            });
            /* */
        },
        addContent(){
            this.contentVisible = true;
        },
        addSureImg(){
            this.sureImgVisible = true;
        },
        addSureImg2(){
            this.sureImgVisible2 = true;
        },
        //主图添加方法
        setImage(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => { 
                this.cropImg = event.target.result;   
            };
            reader.readAsDataURL(file);     
        },
        //主图修改
        addImage(e){
            var that = this;
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const maxSize = 1024 * 1024; // 5MB
            if (file.size > maxSize) {
                this.$message.error(`图片大小不能超过1MB`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {    
                that.$set(that.form1, 'sureImg',event.target.result);     
                this.$nextTick(() => {
                    console.log('视图已更新');
                });
            };
            reader.readAsDataURL(file);   
        }, 
        addImage1(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const maxSize = 100 * 1024; // 5MB
            if (file.size > maxSize) {
                this.$message.error(`图片大小不能超过100kb`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {  
                this.$set(this.form1, 'img1',event.target.result);  
                this.$nextTick(() => {
                    console.log('视图已更新');
                });
            };
            reader.readAsDataURL(file);  
        },
        addImage2(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const maxSize = 100 * 1024; // 5MB
            if (file.size > maxSize) {
                this.$message.error(`图片大小不能超过100kb`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {  
                this.$set(this.form1, 'img2',event.target.result);  
                this.$nextTick(() => {
                    console.log('视图已更新');
                });
            };
            reader.readAsDataURL(file);  
        },
        addImage3(e){
            const file = e.target.files[0];   
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const maxSize = 300 * 1024; // 5MB
            if (file.size > maxSize) {
                this.$message.error(`图片大小不能超过300kb`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {  
                this.$set(this.form1, 'img3',event.target.result);  
                this.$nextTick(() => {
                    console.log('视图已更新');
                });
            };
            reader.readAsDataURL(file);  
        },
        changeImage(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const maxSize = 1024 * 1024; // 5MB
            if (file.size > maxSize) {
                this.$message.error(`图片大小不能超过1MB`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {  
                this.form2.sureImg = event.target.result;
                this.$set(this.form2, 'sureImg',event.target.result);   
                this.$forceUpdate()
            };
            reader.readAsDataURL(file);  
        },
        changeImage1(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const maxSize = 100 * 1024; // 5MB
            if (file.size > maxSize) {
                this.$message.error(`图片大小不能超过100kb`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {  
                this.$set(this.form2, 'img1',event.target.result);  
                this.$forceUpdate()
            };
            reader.readAsDataURL(file);  
        },
        changeImage2(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const maxSize = 100 * 1024; // 5MB
            if (file.size > maxSize) {
                this.$message.error(`图片大小不能超过100kb`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {  
                this.$set(this.form2, 'img2',event.target.result);  
                this.$forceUpdate()
            };
            reader.readAsDataURL(file);  
        },
        changeImage3(e){
            const file = e.target.files[0];   
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const maxSize = 300 * 1024; // 5MB
            if (file.size > maxSize) {
                this.$message.error(`图片大小不能超过300kb`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {  
                this.$set(this.form2, 'img3',event.target.result);  
                this.$forceUpdate()
            };
            reader.readAsDataURL(file);  
        },
        //详情图上传成功追加数据 
        handleChange(file,fileList) {  
            const isJPG =file.raw.type === "image/png" || file.raw.type === "image/jpg" || file.raw.type === "image/jpeg";
            const isLt5M = file.size / 1024    < 1024;
            if (!isJPG) {
                this.$message.error("上传图片只能是 jpg、jpeg、png 格式!");
                fileList.splice(-1, 1);//移除错误文件
                return false;
            }
            if (!isLt5M) {
                this.$message.error("上传图片单张大小不能超过 1MB!");
                fileList.splice(-1, 1);
                return false;
            }  
            this.fileList = fileList;	  
            
        }, 
        //删除图片 
        handleRemove(file, fileList) {  
            let a = file.url ;
            let b = this.form1.detailPlain.indexOf(a);
            this.form1.detailPlain.splice(b,1);
            this.dialogImageUrl.splice(b,1); 
        }, 
        handleRemove(file) {   
            let i = this.fileList.indexOf(file);   
            this.fileList.splice(i,1); 
        }, 
        changeWidth(i){
            if(i==1){
                this.imgWidth = this.imgWidth - 50;
            }else{
                this.imgWidth = this.imgWidth + 50;
            } 
        },
        changeHeight(i){
            if(i==1){
                this.imgHeight = this.imgHeight - 50;
            }else{
                this.imgHeight = this.imgHeight + 50;
            } 
        },
        showMore(){
            if(this.showDiv){
                this.show = '>';
                this.showDiv = false;
            }else{
                this.show = 'v';
                this.showDiv = true;
            } 
        },
        //详情图放大
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true; 
        }, 
        handleBig(url) {
            this.dialogImageUrl = url;
            this.dialogVisible = true; 
        },
        //文件上传超过最大数量提示
        overMaxImg(file,fileList){
            this.$message.error("详情图最多只能上传9张"); 
        },

        changeSelect(){
            this.getSelect6(this.query.ctype);
        },

        //获取下拉框数据
        getSelect(){ 
            this.select = {};  
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select, 'option', res.data);  
                }
            });
        },
        getSelect1(){ 
            this.select1 = {};  
            fetchSelect1(this.select1).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select1, 'option', res.data);  
                }
            });
        },
        getSelect2(){ 
            this.select2 = {}; 
            fetchSelect2(this.select2).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select2, 'option', res.data);  
                }
            });
        },
        getSelect3(){ 
            this.select3 = {}; 
            fetchSelect3(this.select3).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select3, 'option', res.data);  
                }
            });
        },
        getSelect4(){ 
            this.select4 = {}; 
            fetchSelect4(this.select4).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select4, 'option', res.data);  
                }
            });
        },
        getSelect5(){ 
            this.select5 = {};  
            fetchSelect5(this.select5).then(res => {   
                if(res.code=='200'){  
                    this.$set(this.select5, 'option', res.data);  
                }
            });
        },
        getSelect6(ctype){ 
            this.select6 = {}; 
            this.select6.ctype = ctype;
            fetchSelect6(this.select6).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select6, 'option', res.data);  
                }
            });
        },
        getSelect7(){ 
            this.select7 = {};  
            fetchSelect7(this.select7).then(res => {   
                if(res.code=='200'){  
                    this.$set(this.select7, 'option', res.data);  
                }
            });
        },
         downExcel(){
             this.$confirm('确定要下载吗？', '提示', {
                type: 'warning'
            }).then(() => {
                this.loading3 = true;
                var host = localStorage.getItem(window.location.hostname+'_stationUrl');  
                this.query.link1 = window.location.protocol+"//"+host+"/h5/cl/code2_2/";
                this.query.link2 = window.location.protocol+"//"+host+"/h5/goodsDoc/2/";
                setTimeout( () => {
                    this.loading3 = false;  
                    this.getData();
                }, 7000) 
                downOrderExcel(this.query).then(res => {   
                    this.loading3 = false
                    if(res.code=='200'){ 
                        this.$notify({ title: '成功', message: '后台下载成功',duration: 1000, type: 'success' });
                    }else{
                        this.$notify({ title: '失败', message: '后台下载异常',duration: 1000, type: 'error' });
                    }
                });
            });
        },
         getLink2(name,goodsCode){  
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid'); 
            var link = name+"： "+window.location.protocol+"//"+host+"/h5/cl/code2_2/"+goodsCode;
            this.copyLink(link,name);
        },

        getLink1(name,goodsCode){  
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid'); 
            var link = name+"： "+window.location.protocol+"//"+host+"/h5/goodsDoc/2/"+goodsCode;
            this.copyLink(link,name);
        },
         
        // 触发搜索按钮 
        handleSearch() {
            if(this.query.goodsTag){
                this.query.goodsTags = this.query.goodsTag.join();
            }else{
                this.query.goodsTags = "";
            }
            if(this.query.promoteArea){
                this.query.promoteAreas = JSON.stringify(this.query.promoteArea);
            }else{
                this.query.promoteArea = "";
            } 
            if(this.query.goodsId){
                this.query.goodsIds = this.query.goodsId.join();
            }else{
                this.query.goodsIds = "";
            } 
            this.$set(this.query, 'pageIndex', 1);
            this.getData(); 
        },
        refreshSearch2() {
            this.$set(this.query2, 'loginName');
            this.$set(this.query2, 'memPhone'); 
            this.$set(this.query2, 'giveType' ); 
            this.getData2();
        },
        handleSearch2(){
            this.$set(this.query2, 'pageIndex', 1);
            this.getData2();
        },
        refreshSearch3() {
            this.$set(this.query3, 'oname'); 
            this.getCityData();
        },
        handleSearch3(){ 
            this.getCityData();
        },
        getData2(){
            // 获取列表数据   
            this.loading4 = true;
            fetchData3(this.query2).then(res => {  
                this.loading4 = false;
                if(res.code=='200'){ 
                    this.tableData2 = res.data.list;
                    this.pageTotal2 = res.data.pageTotal || 0;   
                }else{
                    this.tableData2 = []; 
                    this.pageTotal2 = 0;
                } 
                
            });
        },
        //查询商品id
        search(channelCode){
            let param = {};
            param.channelCode = channelCode;
            param.mid = this.mid;
            param.stationId = this.stationId;
            getSkuCodes(param).then(res => {   
                if(res.code=='200'){  
                    this.skuCodes = res.data.list;
                    this.skuVisible = true;
                }else{
                    this.$message.error(res.message); 
                }
            });
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'ctype'); 
            this.$set(this.query, 'channelCode' ); 
            this.$set(this.query, 'channelGoodsName'); 
            this.$set(this.query, 'channelGoodsCode');  
            this.$set(this.query, 'goodsRate');  
            this.$set(this.query, 'isp' );   
            this.$set(this.query, 'goodsName');  
            this.$set(this.query, 'goodsCode');  
            this.$set(this.query, 'goodsType');  
            this.$set(this.query, 'goodsFrom');  
            this.$set(this.query, 'goodsComType');  
            this.$set(this.query, 'status');  
            this.$set(this.query, 'promoteStatus');  
            this.$set(this.query, 'promoteArea');  
            this.$set(this.query, 'goodsTag');   
            this.$set(this.query, 'promoteAreas');  
            this.$set(this.query, 'goodsTags');   
            this.$set(this.query, 'goodsId');   
            this.handleSearch();
        },  

         //刷新
        refresh(){
            history.go(0); 
        },
        getImgDetail(goodsCode){ 
            this.imgUrl = window.location.protocol+"//"+localStorage.getItem('ms_indexUrl')+"/hk/imgDetail?st="+this.stationId+"&gc="+goodsCode;
            var height = document.body.scrollHeight; 
            this.imgHeight = height*0.8; 
            this.imgVisible=true;
        },

        //查询
        getData(){
            // 获取列表数据   
            this.loading3 = true;
            fetchGroupData(this.query).then(res => {  
                this.loading3 = false;
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal || 0;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        }, 
        getInfoDetail(goodsCode){
            this.imgUrl = "https://"+localStorage.getItem('ms_indexUrl')+"/hk/infoDetail?st="+this.stationId+"&gc="+goodsCode;
            this.infoVisible=true;
        },
         
        //复制
        handleCopy(index, row){
            row.mid = this.mid;
            row.stationId = this.stationId; 
            handleCopy(row).then(res => {
                if(res.code=='200'){
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    //处理该等级绑定的成员
                    this.$message.error(res.message); 
                } 
            }); 
        },
        //详情
        handDetail(index, row){
            $("#input_box3").html(row.goodsMore);
            //查询商品详情
            let detailParam = {};
            detailParam.stationId = this.stationId;
            detailParam.mid = this.mid;
            detailParam.goodsCode = row.goodsCode;
            backDetailImg(detailParam).then(res => {
                if(res.code=='200'){
                    this.detailImg = res.data; 
                }else{ 
                    this.$message.error(res.message); 
                }  
            });
            this.form3 = row;   
            this.detailVisible = true;   
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val; 
        },
        // 删除
        handDelete(index, row) { 
            row.stationId = this.stationId;  
            row.mid = this.mid;
           
            // 二次确认删除
            this.$confirm('确定要删除 《 '+row.goodsName+' 》 吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.getData();
                    }else{
                        this.$message.error(res.message); 
                    } 
                });
            }) 
        },
        //批量删除
        changeGrade() {
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要删除的商品");
                return;
            }
            var that = this;
            let param = {};
            let goodsCodes = ''; 
            let goodsNames = ''; 
            let title = ''; 
            let ids = '';
            that.delList = that.delList.concat(that.multipleSelection);
            for (let i = 0; i < length; i++) {
                goodsCodes += that.multipleSelection[i].goodsCode + ','; 
                ids += that.multipleSelection[i].id + ','; 
                goodsNames += that.multipleSelection[i].goodsName + ','; 
                title += that.multipleSelection[i].goodsName + '》,《'; 
            }  
                param.goodsCodes = goodsCodes.substr(0,goodsCodes.length-1);  
                param.ids = ids.substr(0,ids.length-1);  
                param.goodsNames = goodsNames.substr(0,goodsNames.length-1);  
                param.mid = that.mid;
                param.stationId = that.stationId;
                title = title.substr(0,title.length-3); 
            // 二次确认删除
            this.$confirm('确定要删除 《'+title+'》 吗？', '提示', {
                type: 'warning'
            }).then(() => { 
                handDeleteBatch(param).then(res => {
                    if(res.code=='200'){ 
                        that.$message.success(res.message); 
                        that.getData();
                    }else{ 
                        that.$message.error(res.message); 
                    } 
                });
            }) 
           

        }, 
         //上下架
        handleStatus(index,row){  
            if(row.status==0){
                this.loadingTitle = "下架";
            }else if(row.status==1){
                this.loadingTitle = "上架";
            } 
            this.loading = true; 
            changeStatus(row).then(res => {
                this.loading = false;
                if(res.code=='200'){  
                    this.$message.success(this.loadingTitle+"成功"); 
                    this.getData();
                }else{ 
                    this.$message.error(this.loadingTitle+"失败"); 
                }  
            }); 
        },

        handleProStatus(index,row){  
            let that = this;
            if(row.promoteStatus==0){ 
                row.promoteStatus='1';
                that.$prompt('请输入暂停推广'+row.goodsName+'原因（不超过50个字）', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',  
                    }).then(({ value }) => {  
                        row.promoteInfo = "人工暂停："+value;
                        row.promoteStatus='0';
                        that.loading = true;
                        changeStatus(row).then(res => {
                        that.loading = false;
                        if(res.code=='200'){  
                            that.$message.success(row.goodsName+"暂停推广成功"); 
                            that.getData();
                        }else{ 
                            that.$message.error(row.goodsName+"暂停推广失败:"+res.message); 
                        }  
                    });   
                }).catch(() => {
                       row.status='1'; 
                });
            }else{ 
                row.promoteInfo = '-'; 
                that.loading = true;
                changeStatus(row).then(res => {
                    that.loading = false;
                    if(res.code=='200'){  
                        that.$message.success(row.goodsName+"开启推广成功"); 
                        that.getData();
                    }else{ 
                        that.$message.error(row.goodsName+"开启推广失败:"+res.message); 
                    }  
                });
            } 
        },
 

        // 新增商品
        addBind() {   
            this.getSelect1();  
            this.getSelect2();  
            this.getSelect3(); 
            this.getSelect4(); 
            this.getSelect5();
            this.getSelect7(); 
            this.getSelect6(''); 
            this.fileList = [];
            this.getSelect6(this.query.ctype); 
            this.saveContent = "0";
            this.addVisible = true; 
        },
        validateNumberInput(input) {
            // 使用正则表达式替换非数字和小数点的字符
            input.value = input.value.replace(/[^0-9.]/g, '');

            // 确保只有一个小数点
            let parts = input.value.split('.');
            if (parts.length > 2) {
                input.value = parts[0] + '.' + parts.slice(1).join('');
            }

            // 确保不以小数点开头
            if (input.value.startsWith('.')) {
                input.value = input.value.substring(1);
            }
        },
       
        //保存新增
        saveForm() {    
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
             if(!this.form1.goodsType){
                this.isSubmitting = false;
                this.$message.error("请填写产品分类");
                return;
            } 
            if(!this.form1.goodsFrom){
                this.isSubmitting = false;
                this.$message.error("请填写产品来源");
                return;
            } 
            if(!this.form1.goodsName){
                this.isSubmitting = false;
                this.$message.error("请填写产品名称");
                return;
            } 
            if( !this.form1.goodsRate ){
                this.isSubmitting = false;
                this.$message.error("请填写商品资费");
                return;
            } 
            if(!this.form1.isp){
                this.isSubmitting = false;
                this.$message.error("请选择计费通道");
                return;
            }    
            if(!this.form1.goodsCom){
                this.isSubmitting = false;
                this.$message.error("请填写产品佣金");
                return;
            }
            if(!this.form1.promoteStart || !this.form1.promoteEnd){
                this.isSubmitting = false;
                this.$message.error("请填写投放时间");
                return;
            }  
            if(this.goodsRead){ 
                this.form1.goodsRead = this.goodsRead.join();
            } 
            if(!this.form1.groupType){
                this.isSubmitting = false;
                this.$message.error("请选择组品类型");
                return;
            }  
            
            if(!this.goodsTag){
                this.isSubmitting = false;
                this.$message.error("请选择产品标签");
                return;
            }else{
                this.form1.goodsTag = this.goodsTag.join();
            } 
            if(this.fileList.length<1){
                this.isSubmitting = false;
                this.$message.error("请上传产品图片");
                return;
            }   
            if(!this.promoteArea || this.promoteArea==''){
                this.isSubmitting = false;
                this.$message.error("请选择推广范围");
                return;
            }else{ 
                this.form1.promoteArea = JSON.stringify(this.promoteArea);
            } 
            if(this.saveContent == "1"){
                this.form1.goodsContent = this.contentVal;
            }
            this.form1.isGroup = '1';
            this.form1.goodsComType = '1'; 
            this.loading = true;  
            this.loadingTitle = "正在保存..."; 
            setTimeout( () => {
                this.isSubmitting = false;
                this.loading = false;   
            }, 8000)  
            saveForm(this.form1).then(res => { 
                if(res.code=='200'){   
                    this.addVisible = false;  
                    this.isSubmitting = false; 
                    //上传产品图片
                    let formData = new FormData();  
                    formData.append("goodsCode",res.data.goodsCode); 
                    formData.append("fileIds","");  
                    for(let j = 0; j < this.fileList.length; j++) {
                        formData.append("files", this.fileList[j].raw,this.fileList[j].name); 
                    }   
                    uploadDetailPlain(formData).then(res => {
                        this.loading = false;   
                        this.refreshSearch();
                        if(res.code=='200'){ 
                            this.$message.success("添加产品成功");  
                        }else{
                            this.addVisible = true;  
                            this.$message.error("产品图片上传失败！请重新编辑上传！"); 
                        }
                    }); 
                }else{
                    this.loading = false;  
                    this.isSubmitting = false; 
                    this.$message.error(res.message); 
                } 
            });
        },
        // 编辑操作
        handleEdit(index, row) {
            this.getSelect1();  
            this.getSelect2();  
            this.getSelect3(); 
            this.getSelect4(); 
            this.getSelect5();
            this.getSelect7(); 
            this.getSelect6(''); 
            let data = {};
            data.goodsCode = row.goodsCode;
            this.saveContent = "0";  
            getGoodsDetail(data).then(res => {
                if(res.code=='200'){ 
                    this.form2 = row;  
                    this.form2.smsSize = res.data.detail.smsSize;  
                    this.form2.sureContent = res.data.detail.sureContent;  
                    this.form2.sureImg = res.data.detail.sureImg;  
                    this.form2.img1 = res.data.detail.img1;  
                    this.form2.img2 = res.data.detail.img2;  
                    this.form2.img3 = res.data.detail.img3;  
                    this.form2.promoteRequire = res.data.detail.promoteRequire;  
                    if(res.data.detail!=null && res.data.detail!=null){
                        if(res.data.detail.promoteArea){
                            this.promoteArea2 = JSON.parse(res.data.detail.promoteArea); 
                        } 
                        if(res.data.detail.goodsContent){ 
                            this.saveContent = '1';
                            this.contentVal = res.data.detail.goodsContent;  
                        } 
                        this.goodsTag2 = res.data.detail.goodsTag.split(",");  
                        if(res.data.detail.goodsRead!=null && res.data.detail.goodsRead!=""){
                            this.goodsRead2 = res.data.detail.goodsRead.split(","); 
                        } 
                    }
                    if(res.data.files!=null && res.data.detail!=null){
                        this.fileList = res.data.files; 
                    }
                      
                    this.editVisible = true;
                }else{ 
                    this.$message.error(res.message); 
                } 
            });     
            
        },
        AesIdEdit(index, row){  
            let data = {};
            data.id = row.id;
            data.stationId = this.stationId;
            data.mid = this.mid;  
            data.aesId = row.aesId;
            data.goodsCode = row.goodsCode;
            updateAesId(data).then(res => {
                if(res.code=='200'){ 
                    this.getData();
                    this.$message.success(res.message);  
                }else{ 
                    this.$message.error(res.message); 
                } 
            });   
        },
        // 保存编辑
        saveEdit() {  
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮  
            if(!this.form2.goodsType){
                this.isSubmitting = false;
                this.$message.error("请填写产品分类");
                return;
            } 
            if(!this.form2.goodsFrom){
                this.isSubmitting = false;
                this.$message.error("请填写产品来源");
                return;
            } 
            if(!this.form2.goodsName){
                this.isSubmitting = false;
                this.$message.error("请填写产品名称");
                return;
            } 
            if( !this.form2.goodsRate ){
                this.isSubmitting = false;
                this.$message.error("请填写商品资费");
                return;
            } 
            if(!this.form2.isp){
                this.isSubmitting = false;
                this.$message.error("请选择计费通道");
                return;
            } 
            if(!this.form2.goodsComType){
                this.isSubmitting = false;
                this.$message.error("请填写结算类型");
                return;
            } 
            if(!this.form2.goodsCom){
                this.isSubmitting = false;
                this.$message.error("请填写产品佣金");
                return;
            }  
            if(this.goodsRead){ 
                this.form2.goodsRead = this.goodsRead2.join();
            } 
            if(!this.goodsTag){
                this.isSubmitting = false;
                this.$message.error("请选择产品标签");
                return;
            }else{
                this.form2.goodsTag = this.goodsTag2.join();
            } 
            if(this.fileList.length<1){
                this.isSubmitting = false;
                this.$message.error("请上传产品图片");
                return;
            }  
            if(!this.promoteArea){
                this.isSubmitting = false;
                this.$message.error("请选择推广范围");
                return;
            }else{
                this.form2.promoteArea = JSON.stringify(this.promoteArea2); 
            } 
            if(this.saveContent == "1"){
                this.form2.goodsContent = this.contentVal;
            }
            this.loading2 = true; 
            setTimeout( () => {
                this.loading2 = false;  
                this.isSubmitting = false; 
                this.editVisible = false; 
            }, 5000)
            changeForm(this.form2).then(res => { 
                this.isSubmitting = false;
                if(res.code=='200'){  
                    this.$message.success(res.message);    
                }else{
                    this.loading2 = false;
                    this.getData();
                    this.$message.error(res.message); 
                }
            });
            setTimeout( () => {
                //上传详情图
                let formData = new FormData(); 
                formData.append("goodsCode",this.form2.goodsCode); 
                var fileIds="";
                var fag = 0;
                for(let j = 0; j < this.fileList.length; j++) {
                    if(this.fileList[j].raw){
                        fag = 1;
                        formData.append("files", this.fileList[j].raw,this.fileList[j].name); 
                    }else{
                        fileIds+= "'"+this.fileList[j].fileId+"',"; 
                    } 
                }  
                if(fileIds.length>1){fileIds=fileIds.substr(0,fileIds.length-1)}
                formData.append("fileIds",fileIds);  
                uploadDetailPlain(formData).then(res => { 
                    this.loading2 = false;
                    this.getData();
                    this.editVisible = false; 
                    if(res.code!='200'){
                        this.$message.error(res.message); 
                    }
                });   
            }, 2000)

           
        },
        copyLink(text,name){  
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);  
            //提示已复制
            this.$message.success(name+"复制成功");  
        },

        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        },
        // 分页导航
        handlePageChange2(val) { 
            this.$set(this.query2, 'pageIndex', val);
            this.getData2();
        },
        //分页数量更改导航
        handleSizeChange2(val){
            this.$set(this.query2, 'pageSize', val);
            this.getData2();
        }
    }
};
</script>
<style> 
.el-drawer.rtl{
    width:60% !important;
}
.chm-imgUl{
   width:560px;height:280px;margin-top:15px;
}
.chm-imgLi{
    list-style: none;
    float:left;width:100px;
    padding:0 20px;
}
.chm-imgFag{
    font-size: 35px;
    color: #ccc;
    position: relative;
    top: -100px;
    left: 30px;
}
.chm-imgDiv{
     position: relative;width: 100px;height: 160px; margin-top:-200px;border: 1px solid #eee;border-radius: 5px;background-color:#eee;opacity:0;box-sizing: border-box;
}
.chm-imgInput{
     width: 100px; height: 160px; cursor: pointer; 
}
.chm-imgTip{
    width:100px;
    background:rgb(245, 105, 24);
    color:#fff;
    height:35px;
    font-size: 13px;
    line-height:35px;
    display:inline-block;
    text-align: center;;
    margin-top:10px;
}
.el-dialog__title{
    font-size: 15px;;
}
 
.el-upload-list--picture-card .el-upload-list__item{
    width:80px ;
    height:80px ;
}
.el-upload--picture-card{
    width:80px ;
    height:80px ;
    line-height:80px ;
}

.ql-container{
    min-height:150px; 
  }
.ql-editor{
	height: 150px;
}
.contentHei .ql-editor{
    height: 450px;
}
#input_box{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
#input_box2{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
#input_box3{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
.imgOper{
    margin-top: -45px; 
    font-size: 18px; 
    float: right;
    margin-right: 20px;
}
.imgOper span{
    margin-right:20px;
}
.imgOper i{
    margin-right:10px;
}
    .el-dialog__body{
        padding:10px 20px;
    }
    .el-dialog__footer{
        padding: 0px 20px 20px;
    }
    .overflowy{

    overflow-x: hidden; /* 设置溢出滚动 */
   white-space: nowrap;
   overflow-y: scroll;
   /* 隐藏滚动条 */
   scrollbar-width: none; /* firefox */
   -ms-overflow-style: none; /* IE 10+ */
}
.overflowy::-webkit-scrollbar {
    display: none; /* Chrome Safari */
 
}
.ttb{
    height:100% !important;
}
</style>
<style scoped> 
.layerDiv{
    position:fixed;
    height:200px;
    background: #333;
    opacity:0.7;
    z-index:100;
}
.input{
    width:80px;height:27px;line-height:27px;text-align:center;color:#ff2222;border:1px solid #aaa;border-radius:5px;font-weight:700 
}
.input:focus {
    outline:none;
    border: 1px solid #fb8a11;
}
.redSpan{
    width:80px;height:30px;line-height:30px;display:inline-block;text-align:center;color:#ff2222;font-weight:700 
}

.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    margin-bottom:5px;
    width: 120px;
    display: inline-block;
}

.handle-input {
    margin-bottom:5px;
    width: 180px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/**/
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
@media screen and (max-width:999px){ 
  
 .goodDetails{
        font-size:12px;line-height:15px;height:18px;overflow-y:auto;
    }
    .goodRight{
        display:block;
    }
} 
@media screen and (min-width:999px){ 
    .goodDetails{
        font-size:15px;line-height:20px;height:22px;overflow-y:auto;
    }
    .goodRight{
        position:absolute;
        left:130px;
    }
}

</style>
